import { createResource, createRoot } from "solid-js";
import {
	getMeteringGrants,
	getSubscription,
	type AccountSubscription,
	type MeteringGrantsResponse,
} from "@/client";

async function fetchSubscription(): Promise<AccountSubscription | null> {
	const res = await getSubscription();
	return res.data?.subscription ?? null;
}

async function fetchGrants(
	_source?: unknown,
	info?: { refetching?: boolean | unknown },
): Promise<MeteringGrantsResponse> {
	const force = info?.refetching === true;
	const response = await getMeteringGrants(
		force ? { query: { force: true } } : {},
	);
	if (response.error || !response.data) {
		throw new Error(
			(response.error as { error?: string } | undefined)?.error ??
				"Could not load usage.",
		);
	}
	return response.data;
}

function createStudioBilling() {
	const [subscription, { refetch: refetchSubscription }] =
		createResource(fetchSubscription);
	const [grants, { refetch: refetchGrants }] = createResource(fetchGrants);

	return { subscription, grants, refetchSubscription, refetchGrants };
}

let shared: ReturnType<typeof createStudioBilling> | undefined;

/** Shared grants and subscription across studio, header, and account pages. */
export function useStudioBilling() {
	if (!shared) {
		shared = createRoot(() => createStudioBilling());
	}
	return shared;
}
